import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LiveAlerts, ShowLiveAlert } from "../../../../Constant";
import { LIVE_ALERT_DATA } from "../../../../Data/UiKit/Alert";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import { useState } from "react";

const LiveAlert = () => {
  const [data, setData] = useState<string[]>([]);

  const dataShown = (key: number) => {
    setData(data.filter((item, index) => index !== key));
  };

  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={LiveAlerts} span={LIVE_ALERT_DATA} />
        <CardBody className="live-dark">
          {data.length > 0 &&
            data.map((item, index) => (
              <Alerts color="light-dark" className="alert-dismissible fade show" key={index}>
                <P className="text-dark">Nice, you triggered this alert message!</P>
                <Btn className="btn-close" onClick={() => dataShown(index)}></Btn>
              </Alerts>
            ))}
          <Btn color="dark" onClick={() => setData(() => [...data, "Alerts"])}>{ShowLiveAlert}</Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LiveAlert;
